import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiV1 } from "../Auth/Interceptor";

const initialStateValue = {
    dashboard: {
        dashboard: {},
        loading: 'idle',
        error: null,
    }
}

const fetchDashboard = createAsyncThunk('orders/fetchDashboard', async () => {
    try {
        const response = await apiV1.get(`dashboard`);
        return response.data.data;
    }
    catch(error) {
        throw error;
    }
});

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: initialStateValue,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchDashboard.pending, (state) => {
            state.dashboard.loading = 'loading';
        })
        .addCase(fetchDashboard.fulfilled, (state, action) => {
            state.dashboard.loading = 'succeeded';
            state.dashboard.dashboard = action.payload;
        })
        .addCase(fetchDashboard.rejected, (state, action) => {
            state.dashboard.loading = 'failed';
            state.dashboard.error = action.error.message;
        });
    },
});

// export const {
// } = dashboardSlice.actions;

export {
    fetchDashboard,
}

export default dashboardSlice.reducer;
